import React from "react";
import Select from "~/ui/select";
import useFilter from "~/cars/hooks/useFilter";
import { convertToMoney } from "~/common/utils/currency";

const yearsToFilter = (initYear = null) => {
  let years = [];

  const currentYear = new Date().getFullYear() + 1;
  const untilYear = initYear ? initYear : 1945;

  for (let index = currentYear; index >= untilYear; index--) {
    years.push({ id: index, year: index });
  }
  return {
    years,
  };
};

const pricesToFilter = (initPrice = null) => {
  let prices = [];

  const maxPrice = 3000000;
  const untilPrice = initPrice ? initPrice : 50000;

  // TODO: Al momento de formatear para el select tomar en cuenta si existe una prop llamada display para usar esa en lugar de la key.

  for (let index = maxPrice; index >= untilPrice; index = index - 50000) {
    prices.push({ id: index, price: index, display: convertToMoney(index) });
    // prices.push({ id: index, price: convertToMoney(index) });
  }
  return { prices };
};

const initializeOptions = (records, recordMeta) => {
  let requests = [];
  let metasRecord = [];
  if (recordMeta) {
    metasRecord = recordMeta.map((m) => m.record);
  }

  if (records.includes("brands")) {
    let endpoint = "/api/brands";
    if (metasRecord.includes("types")) {
      endpoint = endpoint.concat(
        "?type=" + recordMeta.find((f) => f.record === "types").value
      );
    }
    requests = requests.concat(
      fetch(endpoint)
        .then((r) => r.json())
        .then((d) => ({ key: "brands", data: d }))
    );
  }
  if (records.includes("types")) {
    requests = requests.concat(
      fetch("/api/cartypes")
        .then((r) => r.json())
        .then((d) => ({ key: "types", data: d }))
    );
  }

  if (records.includes("years")) {
    requests = requests.concat({ key: "years", data: yearsToFilter() });
  }

  if (records.includes("prices")) {
    requests = requests.concat({ key: "prices", data: pricesToFilter() });
  }

  if (records.includes("cities")) {
    requests = requests.concat(
      fetch("/api/cities")
        .then((r) => r.json())
        .then((d) => ({ key: "cities", data: d }))
    );
  }

  if (metasRecord.includes("brands")) {
    let endpoint =
      "/api/models?brand=" +
      recordMeta.find((f) => f.record === "brands").value;

    if (metasRecord.includes("types")) {
      endpoint = endpoint.concat(
        "&type=" + recordMeta.find((f) => f.record === "types").value
      );
    }

    requests = requests.concat(
      fetch(endpoint)
        .then((r) => r.json())
        .then((d) => ({ key: "models", data: d }))
    );
  }
  return Promise.all(requests);
};

const checkOptions = (posibleOptions, firstOption) => {
  let options = [firstOption];
  if (posibleOptions && posibleOptions.length > 0) {
    options = options.concat(posibleOptions);
  }
  return options;
  // return posibleOptions.length > 0 ? [...]
};

const reduceFilterValues = (filtersFormated, currentFilter) => {
  return {
    ...filtersFormated,
    [currentFilter.key]: currentFilter.value,
  };
};

const handleAppliedFilters = (appliedFilters) => {
  return new Promise((resolve) => {
    const baseManagmentValues = [
      {
        key: "brand",
        value: "all",
      },

      {
        key: "model",
        value: "all",
      },

      {
        key: "type",
        value: "all",
      },
      {
        key: "city",
        value: "all",
      },
      {
        key: "gte-year",
        value: "all",
      },
      {
        key: "lte-year",
        value: "all",
      },
      {
        key: "lte-price",
        value: "all",
      },

      {
        key: "gte-price",
        value: "all",
      },
    ];

    const baseManagmentOptions = [
      {
        resource: "brands",
        key: "brand",
        options: [],
      },

      {
        resource: "types",
        key: "type",
        options: [],
      },

      {
        resource: "models",
        key: "model",
        options: [],
      },
      {
        resource: "cities",
        key: "city",
        options: [],
      },

      {
        resource: "years",
        key: "year",
        options: [],
      },

      {
        resource: "prices",
        key: "price",
        options: [],
      },
    ];

    if (!appliedFilters || appliedFilters.length === 0) {
      // No existen filtros por aplicar entonces setearemos todo por defecto.

      const initializeOptionsResources = baseManagmentOptions.map(
        (i) => i.resource
      );

      initializeOptions(initializeOptionsResources).then((responseOptions) => {
        const initializeData = baseManagmentOptions.reduce((acc, curr) => {
          const options = responseOptions.find((r) => r.key === curr.resource);
          if (options) {
            // Si existen options formateamos si no regresamos []
            const { data } = options;
            const resource = data[curr.resource];
            return {
              ...acc,
              [curr.resource]: resource.map((r) => ({
                key: r.id,
                value: r[curr.key],
                display: r.display || r[curr.key],
              })),
            };
          }
          return {
            ...acc,
            [curr.resource]: [],
          };
        }, {});

        const payloadToSend = {
          options: initializeData,
          values: baseManagmentValues.reduce(reduceFilterValues, {}),
        };
        resolve(payloadToSend);
      });
    } else {
      // TODO: If year key exists remove lte and gte year.
      const filtersExpectedKeys = baseManagmentOptions.map((bo) => bo.key);
      const filtersToApply = appliedFilters.filter((f) => {
        return filtersExpectedKeys.includes(f.key);
      });
      // TODO: Check if lte and gte year exists to set values.
      const metadata = filtersToApply.map((f) => {
        const record = baseManagmentOptions.find((v) => v.key === f.key);
        return {
          record: record.resource,
          value: f.value,
        };
      });
      // TODO: Validate if already exists types
      const records = baseManagmentOptions.map((o) => o.resource);

      initializeOptions(records, metadata).then((values) => {
        const initializeData = baseManagmentOptions.reduce((acc, curr) => {
          // const options = values[index];
          const options = values.find((r) => r.key === curr.resource);
          if (options) {
            const { data } = options;

            const resource = data[curr.resource];
            return {
              ...acc,
              [curr.resource]: resource.map((r) => ({
                key: r.id,
                value: r[curr.key],
                display: r.display || r[curr.key],
              })),
            };
          }
          return {
            ...acc,
            [curr.resource]: [],
          };
        }, {});

        const updatedFilterValues = baseManagmentValues.map((v) => {
          const baseValueInFilters = filtersToApply.find(
            (aF) => aF.key === v.key
          );
          if (baseValueInFilters) {
            return {
              key: v.key,
              value: baseValueInFilters.value,
            };
          }
          return v;
        });

        if (appliedFilters.find((f) => f.key === "gte-price")) {
          updatedFilterValues = updatedFilterValues.map((r) => {
            if (r.key === "gte-price" || r.key === "lte-price") {
              return {
                key: r.key,
                value: appliedFilters.find((f) => f.key === r.key).value,
              };
            }
            return r;
          });
        }

        if (appliedFilters.find((f) => f.key === "gte-year")) {
          updatedFilterValues = updatedFilterValues.map((r) => {
            if (r.key === "gte-year" || r.key === "lte-year") {
              return {
                key: r.key,
                value: appliedFilters.find((f) => f.key === r.key).value,
              };
            }
            return r;
          });
        }

        const payloadToSend = {
          options: initializeData,
          values: updatedFilterValues.reduce(reduceFilterValues, {}),
        };
        resolve(payloadToSend);
      });
    }
  });
};

export default function Filters({ appliedFilters, onSearch }) {
  const { changeFilters, changeValue, filterOptions, filterValues } =
    useFilter();

  React.useEffect(() => {
    handleAppliedFilters(appliedFilters).then((data) => {
      changeFilters(data);
    });
  }, [appliedFilters, changeFilters]);

  function handleChange(event) {
    const { name, value } = event.target;
    // Get dependencies
    /**
     * change Type.
     *  - Get brands by that type
     *  - Clear Models Options
     * Change brand
     *  - Get models of that brand
     *  - If type is selected get models of that brand that have selected type.
     */

    if (name === "brand") {
      let endpoint = "/api/models";
      if (value === "all") {
        // Resetear models.
        changeFilters({
          options: {
            models: [],
          },
          values: {
            brand: value,
          },
        });
        return;
      }

      endpoint = endpoint.concat("?brand=" + value);

      if (filterValues.type !== "all") {
        endpoint = endpoint.concat("&type=" + filterValues.type);
      }

      fetch(endpoint)
        .then((r) => r.json())
        .then((data) => {
          const payload = {
            options: {
              models: data.models.map((m) => ({
                key: m.id,
                value: m.model,
                display: m.model,
              })),
            },
            values: {
              brand: value,
            },
          };
          changeFilters(payload);
        });
    }

    if (name === "type") {
      let endpoint = "/api/brands";
      if (value !== "all") {
        endpoint = endpoint.concat("?type=" + value);
      }

      fetch(endpoint)
        .then((r) => r.json())
        .then((data) => {
          const { brands } = data;
          const payload = {
            options: {
              brands: brands.map((b) => ({
                key: b.id,
                value: b.brand,
                display: b.brand,
              })),
              models: [],
            },
            values: {
              type: value,
              brand: "all",
              model: "all",
            },
          };
          changeFilters(payload);
        });
    }

    if (name === "lte-year") {
      // Set lte-year and gte-year equals when lte-year is higher than gte-year.
      let payload = {
        values: {
          "lte-year": value,
        },
      };
      if (
        filterValues["gte-year"] < value ||
        filterValues["gte-year"] === "all"
      ) {
        payload = {
          values: {
            ...payload.values,
            "gte-year": value,
          },
        };
      }
      changeFilters(payload);
    }

    if (name === "gte-price") {
      let payload = {
        values: {
          "gte-price": value,
        },
      };

      if (
        filterValues["lte-price"] < value ||
        filterValues["lte-price"] === "all"
      ) {
        payload = {
          values: {
            ...payload.values,
            "lte-price": value,
          },
        };
      }
      changeFilters(payload);
    }

    if (
      name === "gte-year" ||
      name === "model" ||
      name === "city" ||
      name === "lte-price"
    ) {
      changeValue({ name, value });
    }
  }

  function handleSearch() {
    onSearch(filterValues);
  }

  return (
    <div className="bg-gray-100 p-4 rounded-sm gap-4 flex flex-col">
      <h3 className="font-medium font-madetommy text-2xl">Busca tu auto</h3>
      <div className="flex gap-6">
        <Select
          name="type"
          label="Tipo..."
  		  style="visibility:hidden"
          value={filterValues.type}
          onChange={handleChange}
          options={[
            { key: 0, value: "all", display: "Tipo..." },
          ]}
        />

        <Select
          name="brand"
          label="Marca..."
          value={filterValues.brand}
          onChange={handleChange}
          options={[
            { key: 0, value: "all", display: "Marca..." },
            ...filterOptions.brands,
          ]}
        />

        <Select
          name="model"
          label="Modelo..."
          value={filterValues.model}
          onChange={handleChange}
          options={checkOptions(filterOptions.models, {
            key: 0,
            value: "all",
            display: "Modelo...",
          })}
        />

        <Select
          name="city"
          label="Ciudad..."
          value={filterValues.city}
          onChange={handleChange}
          options={checkOptions(filterOptions.cities, {
            key: 0,
            value: "all",
            display: "City...",
          })}
        />
      </div>
      <div className="flex gap-6 w-full">
        <div className="flex flex-col w-full">
          <h4 className="font-madetommy pb-2">Rango de año</h4>
          <div className="flex gap-6">
            <Select
              name="lte-year"
              label="Año Minimo..."
              value={filterValues["lte-year"]}
              onChange={handleChange}
              options={checkOptions(filterOptions.years, {
                key: 0,
                value: "all",
                display: "Año Minimo",
              })}
            />

            <Select
              name="gte-year"
              label="Año Maximo..."
              value={filterValues["gte-year"]}
              onChange={handleChange}
              options={checkOptions(
                yearsToFilter(Number(filterValues["lte-year"])).years.map(
                  (y) => ({
                    key: y.id,
                    value: y.year,
                    display: y.year,
                  })
                ),
                { key: 0, value: "all", display: "Año Maximo" }
              )}
            />
          </div>
        </div>
        <div className="flex flex-col w-full">
          <h4 className="font-madetommy pb-2">Rango de precio</h4>
          <div className="flex gap-6">
            <Select
              name="gte-price"
              label="Precio Minimo..."
              value={filterValues["gte-price"]}
              onChange={handleChange}
              options={checkOptions(filterOptions.prices, {
                key: 0,
                value: "all",
                display: "Precio Minimo",
              })}
            />

            <Select
              name="lte-price"
              label="Precio Maximo..."
              value={filterValues["lte-price"]}
              onChange={handleChange}
              options={checkOptions(
                pricesToFilter(Number(filterValues["gte-price"])).prices.map(
                  (p) => ({
                    key: p.id,
                    value: p.id,
                    display: p.display || p.price,
                  })
                ),
                { key: 0, value: "all", display: "Precio Maximo" }
              )}
            />
          </div>
        </div>
      </div>
      <button
        onClick={handleSearch}
        className="font-madetommy font-medium text-sm w-6/12 self-center bg-brand-primary rounded-md px-2 py-2"
      >
        BUSCAR
      </button>
    </div>
  );
}
